import { render } from "./WareInPutaway.vue?vue&type=template&id=72850ffa&scoped=true"
import script from "./WareInPutaway.vue?vue&type=script&lang=js"
export * from "./WareInPutaway.vue?vue&type=script&lang=js"

import "./WareInPutaway.vue?vue&type=style&index=0&id=72850ffa&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72850ffa"]])

export default __exports__